<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt">PUBLISHER: Amy Marson</p>
<p class="copy">CREATIVE DIRECTOR: Gailen Runge</p>
<p class="copy">ACQUISITIONS EDITOR: Roxane Cerda</p>
<p class="copy">MANAGING EDITOR: Liz Aneloski</p>
<p class="copy">EDITOR: Christine Doyle</p>
<p class="copy">TECHNICAL EDITOR: Julie Waldman</p>
<p class="copy">COVER/BOOK DESIGNER: April Mostek</p>
<p class="copy">PRODUCTION COORDINATOR: Tim Manibusan</p>
<p class="copy">ILLUSTRATORS: Tim Manibusan and April Mostek</p>
<p class="copy">PRODUCTION EDITOR: Jennifer Warren</p>
<p class="copy">PHOTO ASSISTANT: Mai Yong Vang</p>
<p class="copy">Styling by Anna Marisa Martinez</p>
<p class="copy">Style photography by Lucy Glover and flat-shot photography by Mai Yong Vang of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy">Published by Stash Books, an imprint of C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?11c360a3